import { useRef, type ChangeEvent } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { useTemplates } from '../../queries/index.js';
import { EmptyState } from '../atoms/EmptyState.jsx';
import { RouterSearchBar } from '../molecules/RouterSearchBar.jsx';
import { TemplatesTable } from '../molecules/TemplatesTable.jsx';

export default function TemplatesTab() {
  const { t } = useTranslation('@myn/import-hub');

  const gridRef = useRef<{ onSearchChange: (search: string) => void } | null>(
    null,
  );

  const { data, isPending } = useTemplates({}, { throwOnError: true });

  const hasNoTemplates = !isPending && !data.totalItems;

  if (hasNoTemplates) {
    return (
      <EmptyState
        icon="IllustrationEmptyState"
        text={t('There are no templates yet')}
        description={t(
          'Click on the button in the top - right corner to start.',
        )}
      />
    );
  }

  return (
    <>
      <RouterSearchBar
        placeholder={t('Search for template name')}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          gridRef.current?.onSearchChange(e.target.value);
        }}
        className="mb-4"
      />
      <TemplatesTable ref={gridRef} />
    </>
  );
}
